import { isEmail, useForm } from '@mantine/form';
import { useState } from 'react';
import type { OrganisationDto } from '../../../util/types/OrganisationDto';
import { validatePhoneNumber } from '../../../util/validation/commonValidation';
import {
	validateConnectionString,
	validateOrganisationName,
} from './useAddOrganisationForm';

export type EditOrganisationDto = OrganisationDto & {};

export function useEditOrganisationForm(organisation: EditOrganisationDto) {
	const [inputs, setInputs] = useState<EditOrganisationDto>(organisation);

	const form = useForm<EditOrganisationDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			name: (value) => validateOrganisationName(value),
			connectionString: (value) => validateConnectionString(value),
			email: isEmail('Email is invalid'),
			phoneNumber: (value) => validatePhoneNumber(value, false),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
